
export default () => {
    return {
        value: window.tg.search_membership || '',
        options: [
            { value: 'vip', label: 'VIP' },
            { value: 'life', label: 'Life' },
            { value: 'none', label: 'None' }
        ],
        multiple: false,
        init() {
            this.$nextTick(() => {
                let choices = new window.Choices(this.$refs.select, {
                    searchEnabled: false,
                    allowHTML: true,
                    itemSelectText: '',
                    shouldSort: false,
                })

                let refreshChoices = (clear = false) => {
                    let selection = this.multiple ? this.value : [this.value]

                    if (clear) {
                        this.$store.search.houseKeeping()
                        choices.clearStore()
                    }

                    choices.setChoices(this.options.map(({ value, label }) => ({
                        value,
                        label,
                        selected: selection.includes(value),
                    })))
                }

                refreshChoices()

                this.$refs.select.addEventListener('change', () => {
                    this.value = choices.getValue(true)
                    this.$store.search.membership = this.value
                })

                this.$watch('value', () => refreshChoices(true))
                this.$watch('options', () => refreshChoices(true))
                this.$watch('$store.search.activeSection', (newValue) => {
                    if (newValue == 'membership') this.showDropdown()
                })

            })
        },
        showDropdown() {
            this.$refs.select.click()
        }
    }
}
